import { AxiosResponse } from "axios";
import { authRequest } from "common/src/utils/request";

export type kei01p = {
  /** 証券番号 */
  tf_kekeno: string;
  /** ポリシー */
  tf_keplcy: string;
  /** 更新回数 */
  tf_keksct: string;
  /** 保険商品コード */
  tf_kehscd: string;
  /** 保険プラン */
  tf_kehkpl: string;
  /** 保険料 */
  tf_kegkhk: number;
  /** 申込日 */
  tf_kemsdt: string;
  /** 責任開始日 */
  tf_kessdt: string;
  /** 始期日 */
  tf_keskdt: string;
  /** 満期日 */
  tf_kemkdt: string;
  /** 料率情報 */
  hsm03p: hsm03p;
  /** 被保険者情報 */
  kei02p: kei02p[];
};

export type hsm03p = {
  /** 商品名称 */
  tf_hrshnm: string;
  /** 補償名称 */
  tf_hrplnm: string;
  /** 家財保険料 */
  tf_hrhrhk: number;
  /** 付帯保険料 */
  tf_hrhthk: number;
  /** 家財保険金額（万円） */
  tf_hrhkkg: number;
  /** 付帯保険金額（万円） */
  tf_hrhtkg: number;
};

export type kei02p = {
  /** 被保険者番号 */
  tf_khhkno: string;
  /** 所有区分 */
  tf_khsykb: string;
  /** 用途 */
  tf_khytkb: string;
  /** 構造 */
  tf_khkozo: string;
  /** 契約者と同じ */
  tf_khkysm: string;
  /** 被保険者カナ */
  tf_khhksk: string;
  /** 被保険者漢字 */
  tf_khhksj: string;
  /** 被保険者性別 */
  tf_khhksx: string;
  /** 被保険者生年月日 */
  tf_khhkbt: string;
};

export type rnw01p = {
  /** 証券番号 */
  tf_rekeno: string;
  /** ポリシー */
  tf_replcy: string;
  /** 更新回数 */
  tf_reksct: string;
  /** 保険商品コード */
  tf_rehscd: string;
  /** 保険プラン */
  tf_rehkpl: string;
  /** 保険料 */
  tf_regkhk: number;
  /** 申込日 */
  tf_remsdt: string;
  /** 責任開始日 */
  tf_ressdt: string;
  /** 始期日 */
  tf_reskdt: string;
  /** 満期日 */
  tf_remkdt: string;
  /** 継続意思 */
  tf_rekzis: string;
  /** 料率情報 */
  hsm03p: hsm03p;
  /** 被保険者情報 */
  rnw02p: rnw02p[];
};

export type rnw02p = {
  /** 被保険者番号 */
  tf_rhhkno: string;
  /** 所有区分 */
  tf_rhsykb: string;
  /** 用途 */
  tf_rhytkb: string;
  /** 構造 */
  tf_rhkozo: string;
  /** 契約者と同じ */
  tf_rhkysm: string;
  /** 被保険者カナ */
  tf_rhhksk: string;
  /** 被保険者漢字 */
  tf_rhhksj: string;
  /** 被保険者性別 */
  tf_rhhksx: string;
  /** 被保険者生年月日 */
  tf_rhhkbt: string;
};

/**
 * API0410 契約・更新契約検索 レスポンスインターフェース
 */
export type searchResponse = {
  /** 契約情報 */
  kei01p?: kei01p | null;
  /** 更新契約情報 */
  rnw01p?: rnw01p | null;
};

/**
 * API0410 契約・更新契約検索
 * @param req
 * @returns
 */
export const getSearchResponse = async (): Promise<AxiosResponse<searchResponse>> => {
  return await authRequest.get("/v1/user/registries/search");
};
